export default __webpack_public_path__ + "static/media/authentication-page-background@2x.8db17d53.png";